import { AxiosResponse } from 'axios';

import { instance as axios } from '../../api/axios';
import { DelayReason, DelayReasonRequest } from './interfaces';

export class DelayReasonService {
  static prefix = '/DelayReason';

  public static async getDelayReasons(statusId?: number): Promise<DelayReason[]> {
    try {
      const response: AxiosResponse<DelayReason[]> = await axios.get(
        DelayReasonService.prefix,
        statusId === undefined ? undefined : { params: { status: statusId } },
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося отримати причини затримки');
    }
  }

  public static async createDelayReason(data: DelayReasonRequest): Promise<DelayReason> {
    try {
      const response: AxiosResponse<DelayReason> = await axios.post(DelayReasonService.prefix, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося створити причину затримки');
    }
  }

  public static async updateDelayReason(data: DelayReasonRequest): Promise<DelayReason> {
    try {
      const response: AxiosResponse<DelayReason> = await axios.put(DelayReasonService.prefix, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося оновити причину затримки');
    }
  }

  public static async deleteDelayReason(id: number): Promise<void> {
    try {
      await axios.delete(`${DelayReasonService.prefix}/${id}`);
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Не вдалося видалити причину затримки');
    }
  }
}
